/// <reference types="vite/client" />
import '../styles/globals.css'
import { mount, hydrate } from 'svelte'
import { createInertiaApp, router } from '@inertiajs/svelte'
import { config } from '@fortawesome/fontawesome-svg-core'

// Both libraries would otherwise inject their CSS as inline <style> elements, which the Content Security Policy blocks.
// Their CSS comes with globals.css instead.
config.autoAddCss = false

// Pages may come from the CDN, so the browser reports each page view to the server itself: on the first page, on every
// visit and when going back or forward. Searches that replace the history entry don't count.
router.on('navigate', () => {
  navigator.sendBeacon('/visits', new URLSearchParams({ path: window.location.pathname }))
})

await createInertiaApp({
  progress: { includeCSS: false },
  resolve: name => {
    const pages = import.meta.glob('../pages/**/*.svelte', { eager: true }) as Record<string, { default: any }>
    return pages[`../pages/${name.replace(/^frontend\//, '')}.svelte`]
  },
  setup({ el, App, props }) {
    if (!el) return

    if (el.dataset.serverRendered) {
      hydrate(App, { target: el, props })
    } else {
      mount(App, { target: el, props })
    }
  },
})
